export default {
  notFoundError: {
    title: 'Oops.',
    description: "Unfortunately we couldn't find the requested page.",
    link: 'Back to home page',
  },
};
